import LoadingIndicator from 'gcs-common/components/LoadingIndicator/LoadingIndicator';
import {
  getSelectedBusinessUnit,
  getSelectedBusinessUnitLoading,
} from 'gcs-common/slices/administration/businessUnits/businessUnitsSelectors';
import { businessUnitSelectionReset } from 'gcs-common/slices/administration/businessUnits/businessUnitsSlice';
import { fetchBusinessUnitDetails } from 'gcs-common/slices/administration/businessUnits/businessUnitsThunks';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import backIcon from '../../../../img/back.svg';
import styles from './styles.module.scss';

const BusinessUnitDetail = () => {
  const { id: businessUnitId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedBusinessUnit = useSelector(getSelectedBusinessUnit);
  const selectedBusinessUnitLoading = useSelector(getSelectedBusinessUnitLoading);

  useEffect(() => {
    (async () => {
      await dispatch(fetchBusinessUnitDetails({ businessUnitId }));
    })();
    return () => dispatch(businessUnitSelectionReset());
  }, [dispatch, businessUnitId]);

  return (
    <div>
      <div className={styles.headerRow}>
        <div className={styles.row}>
          <button className={styles.backButton} type="button" onClick={() => navigate(-1)}>
            <img src={backIcon} alt="back-icon" />
          </button>
          <span className={styles.headerText}>{selectedBusinessUnit?.friendlyName}</span>
        </div>
        {selectedBusinessUnitLoading && <LoadingIndicator padding="0px" />}
      </div>
    </div>
  );
};
export default BusinessUnitDetail;
